import { useI18n } from '../../../shared/i18n/I18nProvider';
import { ReadOnlyModal } from '../../../shared/ui/WorkspaceKit';
import type { Customer } from '../api/customersApi';

export function CustomerEditor({ onClose }: { item: Customer; onClose: () => void; onDone: () => void }) {
  const { t } = useI18n();
  return <ReadOnlyModal feature={t('Chỉnh sửa khách hàng')} onClose={onClose} />;
}
